(function (argument) {
	'use strict';

	angular.module("changdobels")
		.directive("cdValidateMaxDate", cdValidateMaxDate);

	cdValidateMaxDate.$inject = [];

	function cdValidateMaxDate( TEMPLATE_URL ) {
		return {
			require: {
				form: '^^form',
				ngModel: 'ngModel'
			},
			link: function ( scope, element, attributes, controllers ) {
				var link = this;
				var name = attributes.name;

				controllers.form[ name ].$validators.maxDate =
					function ( modelValue ) {
						var maxDate = attributes.cdValidateMaxDate;

						if ( !modelValue || !maxDate ) {
							return true;
						}

						return moment( modelValue, 'YYYY-MM-DD' ) <= moment( maxDate, 'YYYY-MM-DD' );
					};
			}
		};
	}
})();